/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friendprofileblocktitle3Inputs */



/**
* | output |
* | --- |
* | "Block this user?" |
*
* @param {Friendprofileblocktitle3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const friendprofileblocktitle3 = /** @type {((inputs?: Friendprofileblocktitle3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friendprofileblocktitle3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Block this user?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Bloquear a este usuario?")
	return /** @type {LocalizedString} */ ("Заблокировать пользователя?")
});
export { friendprofileblocktitle3 as "friendProfileBlockTitle" }